<template>
  <IQOS class="spacer" :title="$t('campaign_card.iqos_title')">
    <div class="add-campaign-row">
      <BaseInput
        :placeholder="$t('campaign_card.new_campaign_ph')"
        :readonly="false"
        v-model="adding.title"
        @enterPressed="onAddCampaign"
      />
    </div>
    <div class="add-campaign-period iqos-group-item">
      <!-- {{ $t('campaign_card.period') }} -->
      <v-date-picker
        v-model="adding.period.start"
        class="campaign-period-widget"
        placeholder="adasdas"
        locale="uk"
        is-dark
        color="green"
      />
      <span class="add-divider">-</span>
      <v-date-picker
        v-model="adding.period.end"
        class="campaign-period-widget"
        locale="uk"
        is-dark
        color="green"
      />
    </div>

    <IQOSActions
        class="add-campaign-actions"
        :editing="true"
        @cancel="emitClose"
        @accept="onAddCampaign"
      />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import BlackInput from "@/components/BlackInput.vue";

import moment from "moment";



export default {
  components: {
    IQOSActions,
    IQOS,
    BlackInput
  },
  data() {
    return {
      adding: {
        title: null,
        period: null
      }
    };
  },
  methods: {
    onAddCampaign() {
      this.$emit('add', this.adding);
      this.$emit('close');
    },
    emitClose() {
      this.$emit('close');
    }
  },
  mounted() {
    this.adding.title = null;
    this.adding.period = {};
    this.adding.period.start = new Date();
    this.adding.period.end = moment()
      .add(7, "days")
      .toDate();
  }
};
</script>

<style scoped>
.add-campaign-period {
  display: flex;
}

.add-divider {
  color: #ededed;
  margin: 0 1vh;
}

.campaign-period-widget {
  z-index: 10;
}

.spacer {
  margin-bottom: 30vh;
}
</style>